<div class="card mb-4">
  <div class="card-body">
    <h5 class="card-title text-center">Generate WayBill</h5>
    
    <!-- Excel Export Button and Date Range Filter in One Row -->
<div class="row mb-3">
  <!-- Excel Export Button -->
  <div class="col-auto">
    <button class="highlight-link" (click)="exportToExcel()">Export to Excel</button>
  </div>
  
  <!-- From Date Filter -->
  <div class="col-auto">
    <label for="fromDate" class="form-label">From Date</label>
    <input type="date" id="fromDate" class="form-control" [(ngModel)]="fromDate" (change)="applyDateFilter()">
  </div>
  
  <!-- To Date Filter -->
  <div class="col-auto">
    <label for="toDate" class="form-label">To Date</label>
    <input type="date" id="toDate" class="form-control" [(ngModel)]="toDate" (change)="applyDateFilter()">
  </div>

  <div class="col-lg-6 mt-4">
    <!-- Search Input -->
    <input type="text" placeholder="Search by client name, ticket number, or job name , Ref No " class="form-control mb-3" [(ngModel)]="searchText" (input)="onSearch()">
</div>
        <!-- Page Size Selector -->
        <!-- <div class="col-auto">
          <label for="pageSize" class="form-label">Items per page</label>
          <select class="form-control" [(ngModel)]="itemsPerPage" (change)="calculatePagination()">
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div> -->
  
</div>


    <!-- Table -->
    <div class="table-responsive" style="max-height: 600px; overflow-y: auto;">
       <!-- Loader Overlay -->
       <!-- <div *ngIf="loading" class="table-loader-overlay">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div> -->
      <table class="table table-bordered">
        <thead>
          <tr>
            <th (click)="sortTable('dispatch')">Gen WayBill
              <span *ngIf="currentSortColumn === 'dispatch'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('created')">Date
              <span *ngIf="currentSortColumn === 'created'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('ticketno')">Ticket No
              <span *ngIf="currentSortColumn === 'ticketno'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('refNo')">Ref No
              <span *ngIf="currentSortColumn === 'refNo'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('poNo')">PO Number
              <span *ngIf="currentSortColumn === 'poNo'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('clientName')">Customer
              <span *ngIf="currentSortColumn === 'clientName'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('jobName')">Job Name
              <span *ngIf="currentSortColumn === 'jobName'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('orderKgs')">Total Order (Kg)
              <span *ngIf="currentSortColumn === 'orderKgs'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('orderPcs')">Pcs
              <span *ngIf="currentSortColumn === 'orderPcs'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('totalDispatched')">Total Dispatch
              <span *ngIf="currentSortColumn === 'totalDispatched'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('kgsBal')">Remain Bal
              <span *ngIf="currentSortColumn === 'kgsBal'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th (click)="sortTable('status')">Status
              <span *ngIf="currentSortColumn === 'status'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th>
            <th>Status</th>
            <!-- <th (click)="sortTable('manualStatus')"> manual Status
              <span *ngIf="currentSortColumn === 'manualStatus'">
                <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
              </span>
            </th> -->
          </tr>
        </thead>
        <!-- filteredDispatches paginatedDispatches-->
        <tbody>
          <!-- <tr *ngFor="let dispatch of filteredDispatches.reverse()"> -->

             <!-- Iterate over data for the current page -->
  <tr *ngFor="let dispatch of getCurrentPageData()" 
      [ngClass]="{'active-row': dispatch.active}" 
      (click)="setActiveRow(dispatch)">
            <!-- <tr *ngFor="let dispatch of filteredDispatches" 
            [ngClass]="{'active-row': dispatch.active}" 
            (click)="setActiveRow(dispatch)"> -->
            <td>
              <!-- <button 
              [routerLink]="['/DispatchForm', dispatch._id]" 
              [disabled]="dispatch.LamType === 'Closed'"
              [ngClass]="{'btn-secondary': dispatch.LamType === 'Closed'}"> 
              Gen WayBill
            </button> -->
            <button 
            [routerLink]="['/DispatchForm', dispatch._id]" 
            [disabled]="dispatch.manualStatus === 'Closed'"
            [ngClass]="{'btn-secondary': dispatch.manualStatus === 'Closed'}"> 
            Gen WayBill
          </button>
      
            

            </td>
            <td>{{ dispatch.created | date }}</td>
            <td>{{ dispatch.ticketno }}</td>
            <td>{{ dispatch.refNo }}</td>
            <td>{{ dispatch.poNo }}</td>
            <td>{{ dispatch.clientName }}</td>
            <td>{{ dispatch.jobName }}</td>
            <td>{{ dispatch.orderKgs | number:'1.2-2':'en-US' }}</td>
            <td>{{ getNumber(dispatch.orderPcs) | number:'1.0-0':'en-US' }}</td>

            <!-- <td>{{ dispatch.orderPcs | number:'1.0-0':'en-US'}}</td> -->
            <td>{{ dispatch.jssfolderno || 0 }}</td>
            <td>{{ dispatch.jobType || 0 }}</td>
            <td [ngClass]="{
                  'text-danger': dispatch.LamType === 'Repeated Order' || dispatch.LamType === 'ticketGenerated' || dispatch.LamType === null || dispatch.LamType === Pending,
                  'text-primary': dispatch.LamType === 'Open',
                  'text-success': dispatch.LamType === 'Closed',
                  'text-warning': dispatch.LamType === 'Pending' 
                }">
              {{ dispatch.LamType === 'Repeated Order' || dispatch.LamType === 'ticketGenerated'  || dispatch.LamType === 'Pending' || dispatch.LamType === null ? 'Pending' : dispatch.LamType }}
            </td>

            <!-- Add the dropdown for manual status without a default value -->
            <!-- <td>
              <select [(ngModel)]="dispatch.manualStatus" class="form-control"  required>
                <option value="" disabled>Select Manual Status</option> 
                <option value="Keeps Open">Keeps Open</option>
                <option value="Manually Closed">Manually Closed</option>
              </select>
            </td> -->
            <td>
              <select class="form-select "  [(ngModel)]="dispatch.manualStatus" (ngModelChange)="onManualStatusChange($event)" 
             required>
               
                <option value="" disabled selected>Select Manual Status</option>
                <option value="Pending" >Pending</option>
                <option value="Open"> Open</option>
                <option value="Closed"> Closed</option>
              </select>

              <!-- <button (click)="confirmSave(dispatch)">Save</button> -->
            </td>
            
            
            
              <!-- Input to show selected manual status -->
  <td class="disp-none">
    <input type="text" class="form-control " [(ngModel)]="dispatch.manualStatus" placeholder="Selected Manual Status" readonly />
  </td>


            <!-- <td>
              <button 
                class="btn btn-success" 
                (click)="confirmSave(dispatch)"
                [disabled]="dispatch.manualStatus === 'Manually Closed'">
                Save
              </button>
           

              
  <button 
  [routerLink]="['/editDispatchTable', dispatch.ticketno]" 
  class="btn btn-warning btn-sm ms-2">
  Edit
</button>
            </td> -->
            <td *ngIf="dispatch.active">
              <button 
                class="btn btn-success" 
                (click)="confirmSave(dispatch)"
               >
               <!-- [disabled]="dispatch.manualStatus === 'Manually Closed'" -->
                Save
              </button>
            </td>
            

          

          </tr>
          <tr *ngIf="filteredDispatches.length === 0">
            <td colspan="8" class="text-center">No dispatches available</td>
          </tr>
        </tbody>
      </table>
    </div>
       <!-- Pagination Controls -->
       <!-- <nav *ngIf="filteredDispatches.length > itemsPerPage">
        <ul class="pagination justify-content-center">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a class="page-link" (click)="changePage(currentPage - 1)"> <i class="feather icon-chevrons-left"></i></a>
          </li>
          <li class="page-item" *ngFor="let page of pageNumbers" [class.active]="page === currentPage">
            <a class="page-link" (click)="changePage(page)">{{ page }}</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a class="page-link" (click)="changePage(currentPage + 1)"> <i class="feather icon-chevrons-right"></i></a>
          </li>
        </ul>
      </nav> -->

      <div class="pagination-controls text-center">
  <!-- Previous Button -->
  <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1">Previous</button>
  
  <!-- Showing info -->
  <span>
    Showing {{ getStartIndex() + 1 }} - {{ getEndIndex() }} of {{ filteredDispatches.length }}
  </span>
  
  <!-- Next Button -->
  <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages">Next</button>
</div>
  
  </div>
</div>
